export const ISSUE_TRANSITION_VIEW_TYPE = 'IssueTransition' as const;
export const ISSUE_TRANSITION_AGENT_VIEW_TYPE = 'IssueTransitionAgentView' as const;
